import { render } from "./ModalGroup.vue?vue&type=template&id=a59aad4a"
import script from "./ModalGroup.vue?vue&type=script&lang=js"
export * from "./ModalGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__